import { render, staticRenderFns } from "./BLAgentAddressPop.vue?vue&type=template&id=4fbed51a&scoped=true"
import script from "./BLAgentAddressPop.vue?vue&type=script&lang=js"
export * from "./BLAgentAddressPop.vue?vue&type=script&lang=js"
import style0 from "./BLAgentAddressPop.vue?vue&type=style&index=0&id=4fbed51a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbed51a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbed51a')) {
      api.createRecord('4fbed51a', component.options)
    } else {
      api.reload('4fbed51a', component.options)
    }
    module.hot.accept("./BLAgentAddressPop.vue?vue&type=template&id=4fbed51a&scoped=true", function () {
      api.rerender('4fbed51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLAgentAddressPop.vue"
export default component.exports